import React from 'react';
import { UsersIcon } from 'lucide-react';
import { SPOTS } from '../data/site';
export function ScarcityBar() {
  return <div className="rounded-2xl border border-flag/20 bg-white p-4 shadow-soft sm:p-5" data-id="element-63" data-mp="2yv1af7u4ne4v">
      <div className="flex items-center justify-between gap-3" data-id="element-64" data-mp="2l3v4ou098k9j">
        <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-ink-soft" data-id="element-65" data-mp="2q3r7wr14o7o1">
          <UsersIcon className="h-3.5 w-3.5 text-flag" aria-hidden="true" data-id="element-66" data-mp="2b68kpt43m2ip" />
          Promotional spots
        </p>
        <p className="text-[11px] font-extrabold uppercase tracking-[0.1em] text-flag" data-id="element-67" data-mp="2g6w9070y0598">
          {SPOTS.left} of {SPOTS.total} left
        </p>
      </div>

      <div className="mt-3 h-3.5 w-full overflow-hidden rounded-full bg-sand" role="progressbar" aria-valuenow={SPOTS.claimedPercent} aria-valuemin={0} aria-valuemax={100} aria-label={`${SPOTS.claimedPercent}% of promotional spots claimed`} data-id="element-68" data-mp="2755597pyq8i0">
        <div className="h-full rounded-full bg-flag" style={{
        width: `${SPOTS.claimedPercent}%`
      }} data-id="element-69" data-mp="33mv84n6ezh7b" />
      </div>

      <p className="mt-2.5 text-xs leading-relaxed text-ink-soft" data-id="element-70" data-mp="2zk8ceb6mhc4u">
        <strong className="font-bold text-ink" data-id="element-71" data-mp="3dces5w5v5h3r">{SPOTS.claimedPercent}% claimed.</strong> Once the
        remaining spots are taken, the $27 promotional price closes.
      </p>
    </div>;
}